import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Dialog from '../../../1stlog-ui/src/components/Dialog'
import Tariffs from '../Tariffs'
import useTariffDialog from './useTariffDialog'

const Wrapper = styled.div`
  height: 80vh;
  max-height: 80vh;

  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const TariffsDialog = (props) => {
  const { id } = props

  const { isOpen, onSelect, close, initialSearch, title, isFollowup, country } = useTariffDialog(id)

  const onSelectInternal = (data) => {
    // toast.success(
    //   "Zolltarif wurde hinzugefügt. Sie können diesen Dialog schliessen oder weitere Zolltarife hinzufügen."
    // )
    onSelect(data)
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={close}
      closeButton={i18n.t(`btn_close`, `Schliessen`)}
      fullwidth
      title={title || i18n.t('tariff_database', 'Zolltarifdatenbank')}
    >
      <Wrapper>
        {isOpen && (
          <Tariffs
            onSelect={onSelectInternal}
            initialSearch={initialSearch}
            id={id}
            isFollowup={isFollowup}
            country={country}
          />
        )}
      </Wrapper>
    </Dialog>
  )
}

export default TariffsDialog

export { default as useTariffDialog } from './useTariffDialog'
